export default __webpack_public_path__ + "static/media/crisalis-aquino.4cc5e417.png";